import { userService, authService } from '../services'

const state = {
  users: [],
  members: [],
  user: {},
  loading: false,
  error: null,
  membersNotInProject: []
}

const actions = {
  getAll ({ commit }) {
    commit('getAllRequest')
    userService.users().then(
      (users) => commit('getAllSuccess', users),
      (error) => commit('getAllFailure', error)
    )
  },
  async getMembers ({ commit }, projectId) {
    commit('getAllMembersRequest')
    userService.getMembers(projectId).then(
      (members) => commit('getAllMembersSuccess', members),
      (error) => commit('getAllMembersFailure', error)
    )
  },

  async getMembersNotInProject ({ commit }, projectId) {
    commit('getMembersNotInProjectRequest')
    try {
      const response = await userService.getMembersNotInProject(projectId)
      const membersNotInProject = response
      // // // console.log(membersNotInProject)
      commit('getMembersNotInProjectSuccess', membersNotInProject)
    } catch (error) {
      commit('getMembersNotInProjectFailure', error)
    }
  },
  async updateUser ({ dispatch, commit }, user) {
    commit('updateUserRequest')
    try {
      await userService.updateUserProfile(user, user._id)
      commit('updateUserSuccess', user)
      dispatch('alert/success', 'User Profile Updated', { root: true })
    } catch (error) {
      commit('updateUserFailure', error)
      dispatch('alert/error', error, { root: true })
      throw error
    }
  },

  async deleteUser ({ dispatch, commit }, { projectId, userId }) {
    commit('deleteUserRequest')
    try {
      await userService.deleteUser(projectId, userId)
      commit('deleteUserSuccess')
      dispatch('alert/success', 'User Removed from Project', { root: true })
    } catch (error) {
      commit('deleteUserFailure', error)
      dispatch('alert/error', error, { root: true })
    }
  },
  async addMember ({ commit, dispatch }, { projectId, membersWithRoles }) {
    commit('addMemberRequest')
    try {
      // // console.log(membersWithRoles)
      await userService.addMember(projectId, membersWithRoles)
      commit('addMemberSuccess')
      dispatch('alert/success', 'Member(s) added successfully', { root: true })
    } catch (error) {
      commit('addMemberFailure', error)
      dispatch('alert/error', error, { root: true })
    }
  },
  async validateSession ({ commit }) {
    commit('validateSessionRequest')
    try {
      const user = await authService.validateSession()
      commit('validateSessionSuccess', user)
      return user
    } catch (error) {
      commit('validateSessionFailure', error)
      // throw error // Optional: decided not to throw to avoid breaking app init if this fails silently, or maybe I should?
      // Default behavior in this file seems to be commit failure. updateUser throws.
      // I'll re-throw for consistency with some other actions closer to this nature if needed, but let's just commit failure for now or throw?
      // updateUser throws. deleteUser does NOT throw (lines 52-62).
      // Let's NOT throw, just handle state.
    }
  }
}

const mutations = {
  getAllRequest (state) {
    state.loading = true
    state.error = null
  },
  getAllSuccess (state, users) {
    state.loading = false
    state.users = users
  },
  getAllFailure (state, error) {
    state.loading = false
    state.error = error
  },
  getAllMembersRequest (state) {
    state.members = []
    state.loading = true
    state.error = null
  },
  getAllMembersSuccess (state, members) {
    state.loading = false
    state.members = members
  },
  getAllMembersFailure (state, error) {
    state.loading = false
    state.error = error
  },
  updateUserRequest (state) {
    state.loading = true
    state.error = null
  },
  updateUserSuccess (state, updatedUser) {
    state.loading = false
    // Update the member in the members array
    const memberIndex = state.members.findIndex(m => m._id === updatedUser._id)
    if (memberIndex !== -1) {
      state.members.splice(memberIndex, 1, updatedUser)
    }
  },
  updateUserFailure (state, error) {
    state.loading = false
    state.error = error
  },

  deleteUserRequest (state) {
    state.loading = true
    state.error = null
  },
  deleteUserSuccess (state) {
    state.loading = false
  },
  deleteUserFailure (state, error) {
    state.loading = false
    state.error = error
  },
  addMemberRequest (state) {
    state.loading = true
    state.error = null
  },
  addMemberSuccess (state) {
    state.loading = false
  },
  addMemberFailure (state, error) {
    state.loading = false
    state.error = error
  },
  getMembersNotInProjectRequest (state) {
    state.loading = true
    state.error = null
  },
  getMembersNotInProjectSuccess (state, membersNotInProject) {
    state.loading = false
    state.membersNotInProject = membersNotInProject
  },
  getMembersNotInProjectFailure (state, error) {
    state.loading = false
    state.error = error
  },
  validateSessionRequest (state) {
    state.loading = true
    state.error = null
  },
  validateSessionSuccess (state, user) {
    state.loading = false
    state.user = user
  },
  validateSessionFailure (state, error) {
    state.loading = false
    state.error = error
  }
}

export const usersSubmission = {
  namespaced: true,
  state,
  actions,
  mutations
}
